import Aux from './Aux';

export default Aux;